import { useLocation } from "react-router-dom";

/**
 * Hook to get the current tramite from the location state.
 * @returns The current tramite or undefined
 */
export const useCurrentTramite = () => {
  const location = useLocation();

  return location.state?.tramite;
}
